document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

class RavineTheme {
  constructor() {
    this.menu = document.querySelector('[data-mobile-menu]');
    this.search = document.querySelector('[data-search-popover]');
    this.bindMenu();
    this.bindSearch();
    this.bindVariantPickers();
  }

  bindMenu() {
    const toggles = document.querySelectorAll('[data-menu-toggle]');
    if (!this.menu || !toggles.length) return;

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const open = !this.menu.classList.contains('is-open');
        this.menu.classList.toggle('is-open', open);
        this.menu.setAttribute('aria-hidden', String(!open));
        document.body.classList.toggle('menu-open', open);
        toggles.forEach((item) => item.setAttribute('aria-expanded', String(open)));
      });
    });
  }

  bindSearch() {
    const toggles = document.querySelectorAll('[data-search-toggle]');
    if (!this.search || !toggles.length) return;

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const open = this.search.hasAttribute('hidden');
        this.search.toggleAttribute('hidden', !open);
        toggle.setAttribute('aria-expanded', String(open));
        if (open) this.search.querySelector('input')?.focus();
      });
    });
  }

  bindVariantPickers() {
    document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
      const variantData = picker.querySelector('[data-product-variants]');
      const variantSelect = picker.querySelector('[data-variant-select]');
      if (!variantData || !variantSelect) return;

      let variants;
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        return;
      }

      const update = () => {
        const groups = [...picker.querySelectorAll('[data-option-group]')];
        const selectedOptions = groups.map((group) => {
          const selected = group.querySelector('[data-option-value]:checked');
          const selectedLabel = group.querySelector('[data-selected-option]');
          if (selectedLabel && selected) selectedLabel.textContent = selected.value;
          return selected?.value;
        });

        const selectedVariant = variants.find((variant) =>
          variant.options.every((option, index) => option === selectedOptions[index])
        );

        this.updateOptionAvailability(groups, selectedOptions, variants);
        this.updateSelectedVariant(selectedVariant, variantSelect);
      };

      picker.querySelectorAll('[data-option-value]').forEach((input) => {
        input.addEventListener('change', update);
      });

      update();
    });
  }

  updateOptionAvailability(groups, selectedOptions, variants) {
    groups.forEach((group, groupIndex) => {
      group.querySelectorAll('[data-option-value]').forEach((input) => {
        const available = variants.some((variant) => {
          if (!variant.available || variant.options[groupIndex] !== input.value) return false;
          return variant.options.every((option, index) => {
            if (index >= groupIndex) return true;
            return option === selectedOptions[index];
          });
        });

        const label = group.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        label?.classList.toggle('is-unavailable', !available);
        input.setAttribute('aria-disabled', String(!available));
      });
    });
  }

  updateSelectedVariant(variant, variantSelect) {
    const form = variantSelect.closest('form');
    const addButton = form?.querySelector('[data-add-to-cart]');
    const addButtonText = form?.querySelector('[data-add-to-cart-text]');
    const priceContainer = document.querySelector('[data-product-price]');

    if (!variant) {
      variantSelect.value = '';
      if (addButton) addButton.disabled = true;
      if (addButtonText) addButtonText.textContent = 'Unavailable';
      return;
    }

    variantSelect.value = String(variant.id);
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

    if (addButton) addButton.disabled = !variant.available;
    if (addButtonText) addButtonText.textContent = variant.available ? 'Add to field bag' : 'Sold out';

    if (priceContainer) {
      const currency = priceContainer.dataset.currency || 'USD';
      const price = priceContainer.querySelector('[data-price]');
      const comparePrice = priceContainer.querySelector('[data-compare-price]');
      if (price) price.textContent = this.formatMoney(variant.price, currency);
      if (comparePrice) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        comparePrice.hidden = !onSale;
        if (onSale) comparePrice.textContent = this.formatMoney(variant.compare_at_price, currency);
      }
    }

    const mediaId = variant.featured_media?.id || variant.featured_image?.id;
    if (mediaId) {
      document.querySelectorAll('[data-product-gallery] [data-media-id]').forEach((media) => {
        media.classList.toggle('is-selected', media.dataset.mediaId === String(mediaId));
      });
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new RavineTheme());
